import React from 'react';
import { createStructuredSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { ApplicationRootState } from 'types';

import { switchLanguageAction } from '../Configurator/actions/general';

interface StateProps {}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({});

interface SelectValue {
  value: string;
  label: string;
}

const LanguageSelector = () => {
  const dispatch = useDispatch();
  const {} = useSelector(stateSelector);

  const languages = [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'Français' },
    { value: 'nl', label: 'Dutch' },
    { value: 'de', label: 'German' },
  ];

  const onChange = (value: any, { action, removedValue }: any) => {
    if (value) {
      if (action === 'select-option') {
        dispatch(switchLanguageAction(value['value']));
      }
    }
  };

  return (
    <div className="w-28">
      <Select
        options={languages}
        isClearable={false}
        isSearchable={false}
        isMulti={false}
        onChange={onChange}
      />
    </div>
  );
};

export default LanguageSelector;
